import { render, staticRenderFns } from "./shouhou-steps.vue?vue&type=template&id=10bd96c9&scoped=true"
import script from "./shouhou-steps.vue?vue&type=script&lang=js"
export * from "./shouhou-steps.vue?vue&type=script&lang=js"
import style0 from "./shouhou-steps.vue?vue&type=style&index=0&id=10bd96c9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd96c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10bd96c9')) {
      api.createRecord('10bd96c9', component.options)
    } else {
      api.reload('10bd96c9', component.options)
    }
    module.hot.accept("./shouhou-steps.vue?vue&type=template&id=10bd96c9&scoped=true", function () {
      api.rerender('10bd96c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/shouhou-steps.vue"
export default component.exports